/** Hero illustrations for CFP session topic cards. */
import immediateCash from '../../../assets/cfp-topics/immediate-cash.png';
import healthcareBenefits from '../../../assets/cfp-topics/healthcare-benefits.png';
import companyEquity from '../../../assets/cfp-topics/company-equity.png';
import taxSmartMoves from '../../../assets/cfp-topics/tax-smart-moves.png';
import withdrawalsAssets from '../../../assets/cfp-topics/withdrawals-assets.png';
import familyMilestones from '../../../assets/cfp-topics/family-milestones.png';
import transitionRunway from '../../../assets/cfp-topics/transition-runway.png';
import benefitsCoverage from '../../../assets/cfp-topics/benefits-coverage.png';
import careerIncomeStrategy from '../../../assets/cfp-topics/career-income-strategy.png';
import retirementInvestments from '../../../assets/cfp-topics/retirement-investments.png';
import taxPlanning from '../../../assets/cfp-topics/tax-planning.png';
import familyGoals from '../../../assets/cfp-topics/family-goals.png';
import founderRunway from '../../../assets/cfp-topics/founder-runway.png';
import businessStructure from '../../../assets/cfp-topics/business-structure.png';
import founderBenefits from '../../../assets/cfp-topics/founder-benefits.png';
import taxStrategy from '../../../assets/cfp-topics/tax-strategy.png';
import riskFamily from '../../../assets/cfp-topics/risk-family.png';

export const CFP_TOPIC_IMAGES = {
  'immediate-cash': immediateCash,
  'healthcare-benefits': healthcareBenefits,
  'company-equity': companyEquity,
  'tax-smart-moves': taxSmartMoves,
  'withdrawals-assets': withdrawalsAssets,
  'family-milestones': familyMilestones,
  'transition-runway': transitionRunway,
  'benefits-coverage': benefitsCoverage,
  'career-income-strategy': careerIncomeStrategy,
  'retirement-investments': retirementInvestments,
  'tax-planning': taxPlanning,
  'family-goals': familyGoals,
  'founder-runway': founderRunway,
  'business-structure': businessStructure,
  'founder-benefits': founderBenefits,
  'tax-strategy': taxStrategy,
  'risk-family': riskFamily,
};

export function getTopicImage(topicId) {
  return CFP_TOPIC_IMAGES[topicId] ?? immediateCash;
}
